import { useEffect } from "react";

const BASE_URL = "https://ozzieetech.com.au";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Per-page SEO meta: unique title, description, canonical + Open Graph tags
export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", `${BASE_URL}${path}`);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "OzzieeTech");
    upsertCanonical(`${BASE_URL}${path}`);
  }, [title, description, path]);
  return null;
};
